<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="placementsTable.additionalFilters"
                                    :default-sort="placementsTable.defaultSort"
                                    :excel="true"
                                    :fields="placementsTable.headers"
                                    :header-selection-key="'placements----headers'"
                                    :height="placementsTable.height"
                                    :total-records="placementsTable.total"
                                    :filter-save-key="'placements----filters'"
                                    @excel="excelExport"
                                    @headers="selectHeaders"
                                    @reload="reloadData"
                                >
                                    <tr
                                        v-for="(item, key) in placementsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(item.id, true)"
                                    >
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('id')"
                                            class="text-right"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.id }}
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('invoice_to_display')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.invoice_to_display }}
                                            <v-tooltip bottom v-if="$myStore.state.user.user_role_id == 1">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-icon
                                                        class="pl-2"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click.stop="opentEntity(item.entity_id, false)"
                                                        small
                                                        >fas fa-link</v-icon
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.openEntityInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('placement_status')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <!-- planned -- žuta -->
                                            <v-chip
                                                v-if="item.placement_status_id == 2"
                                                class="text-uppercase pl-4"
                                                text-color="#BBBB00"
                                                color="#E1E10040"
                                                ><v-icon x-small left color="#BBBB00"> fas fa-circle </v-icon
                                                >{{ item.placement_status_display }}</v-chip
                                            >
                                            <!-- canceled -- crvena -->
                                            <v-chip
                                                v-if="item.placement_status_id == 7"
                                                class="text-uppercase pl-4"
                                                text-color="#FF0000"
                                                color="#FF000040"
                                                ><v-icon x-small left color="#FF0000"> fas fa-circle </v-icon
                                                >{{ item.placement_status_display }}</v-chip
                                            >
                                            <!-- completed -- siva -->
                                            <v-chip
                                                v-if="item.placement_status_id == 8"
                                                class="text-uppercase pl-4"
                                                text-color="#212528"
                                                color="#a3b8c9"
                                                ><v-icon x-small left color="#212528"> fas fa-circle </v-icon
                                                >{{ item.placement_status_display }}</v-chip
                                            >
                                            <!-- contract -- plava -->
                                            <v-chip
                                                v-if="item.placement_status_id == 9"
                                                class="text-uppercase pl-4"
                                                text-color="#49707c"
                                                color="#92e0f7"
                                                ><v-icon x-small left color="#49707c"> fas fa-circle </v-icon
                                                >{{ item.placement_status_display }}</v-chip
                                            >
                                        </td>
                                        <td
                                            v-if="
                                                placementsTable.selectedHeaders.includes('seafarer_status') &&
                                                item.placement_status_id != 7 &&
                                                item.placement_status_id != 8
                                            "
                                            @click="editClick(item.id, false)"
                                        >
                                            <!-- siva  -- inactive -->
                                            <v-chip
                                                v-if="item.seafarer_status_id == 1"
                                                class="text-uppercase pl-4"
                                                text-color="#212528"
                                                color="#a3b8c9"
                                                ><v-icon x-small left color="#212528"> fas fa-circle </v-icon
                                                >{{ item.seafarer_status_display }}</v-chip
                                            >
                                            <!--  roza -- sick leave -  -->
                                            <v-chip
                                                v-else-if="item.seafarer_status_id == 2 || item.seafarer_status_id == 6"
                                                class="text-uppercase pl-4"
                                                text-color="#ac8ea9"
                                                color="#f5cbf1"
                                                ><v-icon x-small left color="#ac8ea9"> fas fa-circle </v-icon
                                                >{{ item.seafarer_status_display }}</v-chip
                                            >
                                            <!-- available -- zelena -->
                                            <v-chip
                                                v-else-if="item.seafarer_status_id == 3"
                                                class="text-uppercase pl-4"
                                                text-color="#008000"
                                                color="#00800040"
                                                ><v-icon x-small left color="#008000"> fas fa-circle </v-icon
                                                >{{ item.seafarer_status_display }}</v-chip
                                            >
                                            <!--  on leave; travel to vessel; training,visa,etc.; travel from vessel -- bez boje   -->
                                            <v-chip
                                                v-else-if="
                                                    item.seafarer_status_id == 4 ||
                                                    item.seafarer_status_id == 5 ||
                                                    item.seafarer_status_id == 7 ||
                                                    item.seafarer_status_id == 9
                                                "
                                                class="text-uppercase pl-4"
                                                text-color="#000000"
                                                color="#ffffff"
                                                ><v-icon x-small left color="#000000"> fas fa-circle </v-icon
                                                >{{ item.seafarer_status_display }}</v-chip
                                            >
                                            <!-- on board -- plava -->
                                            <v-chip
                                                v-else-if="item.seafarer_status_id == 8"
                                                class="text-uppercase pl-4"
                                                text-color="#49707c"
                                                color="#92e0f7"
                                                ><v-icon x-small left color="#49707c"> fas fa-circle </v-icon
                                                >{{ item.seafarer_status_display }}</v-chip
                                            >
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-icon
                                                        class="pl-2"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click.stop="openSeafarerActivity(item.seafarer_id, false)"
                                                        small
                                                        >fas fa-link</v-icon
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.openSeafarerActivity') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            v-else-if="placementsTable.selectedHeaders.includes('seafarer_status')"
                                            @click="editClick(item.id, false)"
                                        ></td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="placementsTable.selectedHeaders.includes('seafarer')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.seafarer_display }}
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-icon
                                                        class="pl-2"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click.stop="openSeafarer(item.seafarer_id, false)"
                                                        small
                                                        >fas fa-link</v-icon
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.openSeafarer') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('rank')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.rank_display }}
                                        </td>
                                        <td
                                            class="font-weight-bold"
                                            v-if="placementsTable.selectedHeaders.includes('maritime_object')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.maritime_object_display }}
                                            <v-tooltip bottom v-if="$myStore.state.user.user_role_id == 1">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-icon
                                                        class="pl-2"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        @click.stop="openMaritimeObject(item.maritime_object_id, false)"
                                                        small
                                                        >fas fa-link</v-icon
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.openMaritimeObjectInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('seafare_nationality')"
                                            @click="editClick(item.id, false)"
                                        >
                                            {{ item.nationality_display }}
                                        </td>

                                        <td
                                            v-if="placementsTable.selectedHeaders.includes('sign_on_date')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <span v-if="item.placement_status_id == 2">
                                                {{ item.sign_on_date_display }}</span
                                            >
                                        </td>
                                        <td
                                            class="text-center"
                                            v-if="placementsTable.selectedHeaders.includes('notify_for_extension')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-chip
                                                v-if="item.past"
                                                class="text-uppercase pl-4"
                                                text-color="#FF0000"
                                                color="#FF000040"
                                                >{{ item.notify_for_extension_display }}</v-chip
                                            >

                                            <v-chip
                                                v-if="!item.past && item.notify_for_extension_display != '-'"
                                                class="text-uppercase pl-4"
                                                text-color="#6F6F6F"
                                                color="#6F6F6F40"
                                                >{{ item.notify_for_extension_display }}</v-chip
                                            >
                                            <span v-if="item.notify_for_extension_display == '-'">{{
                                                item.notify_for_extension_display
                                            }}</span>
                                        </td>
                                        <td
                                            class="text-center"
                                            v-if="placementsTable.selectedHeaders.includes('all_approved')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-tooltip
                                                bottom
                                                v-if="item.all_approved == true && item.has_biling_records"
                                            >
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        small
                                                        color="#4360DF40"
                                                        fab
                                                        depressed
                                                    >
                                                        <v-icon small color="#4360DF">fas fa-thumbs-up</v-icon></v-btn
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.allItemsAreApproved') }}</span>
                                            </v-tooltip>
                                            <v-tooltip
                                                bottom
                                                v-if="item.all_approved == false && item.has_biling_records"
                                            >
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        small
                                                        color="#E1E10040"
                                                        fab
                                                        depressed
                                                    >
                                                        <v-icon small color="#BBBB00"
                                                            >fas fa-exclamation-triangle</v-icon
                                                        ></v-btn
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.thereAreUnapprovedItems') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td
                                            class="text-center"
                                            v-if="placementsTable.selectedHeaders.includes('all_billing')"
                                            @click="editClick(item.id, false)"
                                        >
                                            <v-tooltip bottom v-if="item.all_billing && item.has_biling_records">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        small
                                                        color="#00800040"
                                                        fab
                                                        depressed
                                                    >
                                                        <v-icon small color="#008000">fas fa-coins</v-icon></v-btn
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.allItemsSentToBilling') }}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom v-if="!item.all_billing && item.has_biling_records">
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        small
                                                        color="#E1E10040"
                                                        fab
                                                        depressed
                                                    >
                                                        <v-icon small color="#BBBB00"
                                                            >fas fa-exclamation-triangle</v-icon
                                                        ></v-btn
                                                    >
                                                </template>
                                                <span>{{ $t('tooltips.thereAreItemsNotSentToBilling') }}</span>
                                            </v-tooltip>
                                        </td>
                                        <td class="text-right">
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{on, attrs}">
                                                    <v-btn
                                                        icon
                                                        v-bind="attrs"
                                                        @click="editClick(item.id, true)"
                                                        v-on="on"
                                                    >
                                                        <v-icon small>fa-external-link-alt</v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>{{ $t('tooltips.openInNewTab') }}</span>
                                            </v-tooltip>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Placements',
    components: {TheTable},
    data: function () {
        return {
            placementsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.id'), value: 'id', type: 'string', allowFilter: true, width: '60px'},
                    {text: this.$t('fields.invoiceTo'), value: 'invoice_to_display', type: 'dropdown|entities'},
                    {
                        text: this.$t('fields.status'),
                        value: 'placement_status',
                        type: 'multiple|placement-statuses',
                        width: '150px',
                    },
                    {
                        text: this.$t('fields.seafarerStatus'),
                        value: 'seafarer_status',
                        type: 'multiple|seafarer-statuses',
                        width: '150px',
                    },

                    {text: this.$t('fields.seafarer'), value: 'seafarer', type: 'string', allowFilter: true},
                    {
                        text: this.$t('fields.rank'),
                        value: 'rank',
                        type: 'multiple|ranks-abbreviation',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.maritimeObject'),
                        value: 'maritime_object',
                        type: 'string',
                        allowFilter: true,
                    },
                    {
                        text: this.$t('fields.seafarerNationality'),
                        value: 'seafare_nationality',
                        type: 'multiple|nationalities',
                        allowFilter: true,
                    },

                    {text: this.$t('fields.plannedSignOn'), value: 'sign_on_date', type: 'date'},
                    {
                        text: this.$t('fields.notifyForExtension'),
                        value: 'notify_for_extension',
                        type: 'boolean',
                        default: null,
                        defaultDisplay: this.$t('labels.yes'),
                    },
                    {
                        text: this.$t('fields.allApproved'),
                        value: 'all_approved',
                        type: 'boolean',
                        default: null,
                        defaultDisplay: this.$t('labels.yes'),
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.allBilling'),
                        value: 'all_billing',
                        type: 'boolean',
                        default: null,
                        defaultDisplay: this.$t('labels.yes'),
                        sortable: false,
                    },

                    {text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false},
                ],
                additionalFilters: [
                    {
                        text: this.$t('fields.dataRange'),
                        value: 'data_range',
                        type: 'placement_sign_on_date_range',
                    },
                ],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'id',
                    descending: true,
                },
            },
        };
    },
    methods: {
        openSeafarer(seafarerId) {
            if (this.$myStore.state.user.user_role_id == 1) {
                let routeData = this.$router.resolve('/seafarers/' + seafarerId);
                window.open(routeData.href, '_blank');
            }
        },
        opentEntity(entityId) {
            if (this.$myStore.state.user.user_role_id == 1) {
                let routeData = this.$router.resolve('/entities/' + entityId);
                window.open(routeData.href, '_blank');
            }
        },
        openMaritimeObject(maritimeObjectId) {
            if (this.$myStore.state.user.user_role_id == 1) {
                let routeData = this.$router.resolve('/maritime-objects/' + maritimeObjectId);
                window.open(routeData.href, '_blank');
            }
        },
        openSeafarerActivity(seafarerId) {
            if (this.$myStore.state.user.user_role_id == 1) {
                this.$myStore.commit('setOpenActivity', true);
                this.$nextTick(() => {
                    this.$router.push('/seafarers/' + seafarerId);
                });
            }
        },
        addClick() {
            this.$router.push('/placements/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/placements/' + id);
            } else {
                let routeData = this.$router.resolve('/placements/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.placementsTable.selectedHeaders = headers;
        },
        reloadData(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall('get', 'placements', request, (data, success) => {
                if (success) {
                    vm.placementsTable.items = data.items;
                    vm.placementsTable.total = data.total;
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        excelExport() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall('get', 'placements', excelRequest, (data, success) => {
                if (success) {
                    vm.$APICall('post', 'excel/placements', data.items, (data) => {
                        window.open(data.link);
                    });
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        resolveWindowResize() {
            this.placementsTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.placements'), href: '/#/placements', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
